import { UrlConstants } from "../url.constants";
export class ApiRatesCertificateConstants {
    static URL = UrlConstants.API_V2 + "RatesCertificate";
    static FUNCTION_SET_APPLICANT_AND_APPLICANT_AGENT = "SetRatesCertificateApplicantAndApplicantAgent";
    static FUNCTION_SET_PROPERTIES = "SetRatesCertificateProperties";
    static FUNCTION_GET_GENERATE_INVOICE = "GenerateRatesCertificateInvoiceReport";
    static FUNCTION_CREATE_PARTIAL_APPLICATION = "CreatePartialPortalRatesCertificateApplication";
    static FUNCTION_GET_GENERATE_REQUIRED_DOCUMENTS_CHECKLIST = "GetRatesCertificateRequiredDocumentsChecklist";
    static FUNCTION_GET_EXTERNAL_LINKS = "GetExternalLinks";
    static FUNCTION_APPLICATION_TYPES = "GetRcApplicationTypes";
}
